export const DEFAULT_IMAGE_QUALITY = 90;
